import Request from 'redux/config/services/Request'
import { PayrollProvider } from './finchTypes'

export const getPayrollProviders = async (): Promise<PayrollProvider[]> => {
  const response = await Request.get('/finch/providers')
  return response.data
}
